import { message, Modal, Row, Col, Tooltip } from 'antd';
import React, { Component } from 'react';
import EventCard from "./EventGraph"
import { InfoCircleOutlined } from '@ant-design/icons';
import { DashOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { NON_TIME_BOUND_PROJECT_DETAILS } from './Constant';
import { APPROVED, NOTAPPROVED } from '../../constant';
class DefaultCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            selectedProjectName: null,
            isReduceModal: false
        };
    }
    showModal = () => {
        this.setState({ isModalVisible: true, selectedProjectName: this.props.projectName, isReduceModal: false });
    }
    handleCancel = () => {
        this.setState({ isModalVisible: false, selectedProjectName: null, isReduceModal: false });
    }
    showReduceModal = () => {
        this.setState({ isModalVisible: false, selectedProjectName: this.props.projectName, isReduceModal: true });
    }

    render() {
        const error = function () {
            Modal.warning({
                title: 'Warning',
                content: "Today's time limit has been exceeded."
            });
        };
        const projectTooltip = NON_TIME_BOUND_PROJECT_DETAILS[this.props.event.projectName]
        return (
            <div className="task_event_cardTab_main"
                style={this.props.event.isApproved === APPROVED ? { pointerEvents: "none", opacity: 0.5 } : {}}>
                <div className="task_event_cardTab_main1">
                    <div className="task_event_reduce" >
                        <div>
                            <DashOutlined className="fa fa-minus" style={{ fontSize: 20, color: "#0047AB", rotate: "90deg", marginLeft: "25px" }} onClick={() => { this.showModal(); }} />
                        </div>
                        <div className="reduce_button_event" onClick={() => { (this.props.event.projectAssignId != 0 && this.props.event.time > 0 ? this.props.reduceTime(this.props.event.projectAssignId, 1) : message.error("Minimum Limit Reach")) }}>
                            <div className="reduce_button_event_content">
                                -
                            </div>
                        </div>

                    </div>
                    <div className="task_event_cardTab">
                        <div className="task_event_graph">
                            <EventCard
                                event={this.props.event}
                                addTime={(id, defaultProjectId, value) => {
                                    if (this.props.totalTime <= 23) {
                                        this.props.addTime(id, defaultProjectId, value)
                                    } else {
                                        error();
                                    }
                                }}
                                time={this.props.event.time}
                                data={[{ name: "time", stroke: "#888888", fill: "#f12c06", value: (this.props.event.time / 24) * 100 }, { name: "time", stroke: "#888888", fill: "#888888", value: ((24 - this.props.event.time) / 24) * 100 }]} />
                        </div>
                        <div className="task_event_Name">
                            <p className="task_event_eventName">{this.props.event.projectName}
                                {projectTooltip ?
                                    <Tooltip title={`${projectTooltip}`} placement="top">
                                        <InfoCircleOutlined className="info_icon" style={{ marginLeft: '8px', color: '#1890ff', cursor: 'pointer' }} />
                                    </Tooltip> : <></>}
                            </p>
                        </div>

                    </div>
                    <Modal
                        open={this.state.isModalVisible}
                        footer={null}
                        onCancel={this.handleCancel}
                        centered
                        className="custom-modal"
                    >
                        <div
                            style={{
                                display: 'content',
                                justifyContent: 'center',
                                alignItems: "center",
                            }}
                        >
                            <Col>
                                <Row style={{ width: "100%", justifyContent: "center" }}>
                                    <h6 style={{ fontWeight: "600", color: "gray" }}>Total Time Logged</h6>
                                </Row>
                                <Row style={{ width: "100%", justifyContent: "center", fontWeight: "700" }}>
                                    <h5>{this.props.event.projectName}</h5>
                                </Row>
                                <Row style={{ paddingLeft: '35%' }}>
                                    <h2 fontSize={25} fill="white" dominantBaseline="central" style={{ textAlign: "start", cursor: "pointer", paddingRight: "2%" }}>
                                        {`${parseInt(this.props.event.time) + "H"}`}
                                    </h2>
                                    <h2 fontSize={12} fill="white" dominantBaseline="central" style={{ textAlign: "center", cursor: "pointer", paddingLeft: "1%" }}>
                                        {`${(this.props.event.time % 1) * 60 + "min"}`}
                                    </h2>
                                </Row>
                                <hr style={{ border: "1px solid black", margin: "5px" }} />
                                <Row style={{ width: "100%", justifyContent: "center" }}>
                                    <div style={{ display: "flex", width: "50%", flexDirection: "row", justifyContent: "space-evenly" }}>
                                        <div style={{ display: "flex", width: "20%", height: "100px", flexDirection: "row", fontWeight: "600" }}><MinusOutlined style={{ fontSize: '40px', color: "#0047AB" }}
                                            onClick={() => {
                                                this.props.reduceTime(this.props.event.projectAssignId, 0.25);
                                            }} /></div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <span style={{ fontSize: '60px', height: "100px", color: "#0047AB", fontWeight: "600" }}>15</span></div>
                                        <div style={{ display: "flex", width: "20%", height: "100px", flexDirection: "row", fontWeight: "600" }}>
                                            <PlusOutlined style={{ fontSize: '40px', color: "#0047AB" }}
                                                onClick={() => {
                                                    this.props.addTime(this.props.event.projectAssignId, this.props.event.projectId, 0.25);
                                                }} />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </div>
                    </Modal >
                </div>
                <div className="task_event_cardTab_status">
                    {this.props.event.isApproved === APPROVED ? (
                        <div className="task_card_touch_description_Approve"></div>
                    ) : this.props.event.time === NOTAPPROVED ? (
                        <></>
                    ) : (
                        <div className="task_card_touch_description_Pending"></div>
                    )}
                </div>

            </div>
        );
    }
}

export default DefaultCard;